/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { RichTextSimple } from "@simplicitycms/simplicity-richtext";
import { QuickSearch } from "components/search";

const HeroSlideshowSlide = (props) => {

    const { slides, images, index } = props || {};

    const slide = slides[index];
    const image = Array.isArray(images) && images[index];
    const { src, alt } = image || {};

    const { title, subtitle = "", description, link } = slide || {};
    const { text, url: link_url } = link || {};

    return (
        <div className='hero-slideshow-slide'>
            <div className='hero-slideshow-image-wrapper'>
                <img alt={alt} src={src} />
            </div>
            <div className='langley-banner'>
                <QuickSearch />
            </div>
            <div className='hero-slideshow-content-container'>
                <div className='hero-slideshow-content'>

                    <div className='hero-slideshow-details'>
                        <h1>
                            {title}
                            {subtitle && <span>{` ${subtitle}`}</span>}
                        </h1>

                        <RichTextSimple
                            richtext={description}
                            className='hero-slideshow-description'
                        />

                        <Link to={link_url} className='hero-slideshow-link'>
                            {text}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
export { HeroSlideshowSlide };
